/* La Maison Para: choix d'une note avant le formulaire officiel Judge.me. */
(function () {
  'use strict';
  if (window.__LMP_EMPTY_REVIEW_STARS_READY) return;
  window.__LMP_EMPTY_REVIEW_STARS_READY = true;

  function setVisualRating(container, rating) {
    container.setAttribute('data-selected-rating', String(rating));
    container.querySelectorAll('[data-lmp-star]').forEach(function (star) {
      var n = Number(star.getAttribute('data-lmp-star'));
      star.textContent = n <= rating ? '★' : '☆';
      star.setAttribute('aria-pressed', n === rating ? 'true' : 'false');
    });
  }

  function tryFillJudgeRating(rating) {
    var forms = Array.prototype.slice.call(document.querySelectorAll('.jdgm-form, .jdgm-form-wrapper, .jm-review-form, [role="dialog"]'));
    var root = forms.find(function (node) { return node.offsetParent !== null; });
    if (!root) return;
    var radios = root.querySelectorAll('input[type="radio"][name*="rating"], input[type="radio"][name*="score"]');
    for (var i = 0; i < radios.length; i++) {
      if (Number(radios[i].value) === rating) {
        radios[i].click();
        return;
      }
    }
    var legacyStars = root.querySelectorAll('.jdgm-form__rating .jdgm-star');
    if (legacyStars.length >= rating) legacyStars[rating - 1].click();
  }

  document.addEventListener('click', function (event) {
    var star = event.target.closest('[data-lmp-no-product-review] [data-lmp-star]');
    if (!star) return;
    event.preventDefault();
    var root = star.closest('[data-lmp-no-product-review]');
    var selected = Number(star.getAttribute('data-lmp-star'));
    if (!root || selected < 1 || selected > 5) return;
    setVisualRating(root, selected);

    var widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;
    widget.scrollIntoView({behavior:'smooth', block:'start'});

    var attempts = 0;
    function openOfficialForm() {
      var open = widget.querySelector('.jdgm-write-rev-link, .jm-review-widget__write-review-button, .jm-write-review-button, [data-testid="write-review-button"]');
      if (open && open.offsetParent !== null) {
        open.click();
        window.setTimeout(function () {tryFillJudgeRating(selected);}, 250);
        window.setTimeout(function () {tryFillJudgeRating(selected);}, 750);
        return;
      }
      attempts++;
      if (attempts < 15) window.setTimeout(openOfficialForm, 300);
    }
    window.setTimeout(openOfficialForm, 350);
  });
})();